<script setup>
import { computed, inject } from 'vue';
import SiteButton from '../SiteButton.vue';
import { buttonItems, buttonsAlign } from '../buttons.js';
import { styleVars } from './shared.js';

const props = defineProps({
    config: { type: Object, required: true },
    accent: { type: String, default: '' },
    org: { type: Object, default: () => ({}) },
    site_data: { type: Object, default: () => ({}) },
});

// No buttons is no block for a visitor, heading included; the editor
// keeps its prompt (Mus, 2026-10-11).
const editing = inject('tiqEditorCanvas', false);
const items = computed(() => buttonItems(props.config));
const align = computed(() => buttonsAlign(props.config));
</script>

<template>
    <section v-if="items.length || editing" :id="config.anchor_id || null" class="th-block th-sec th-btns" :class="`th-btns--${align}`" :style="styleVars(config)">
        <div class="th-wrap">
            <div v-if="config.eyebrow || config.heading || config.intro" class="th-btns__head">
                <p v-if="config.eyebrow" class="th-eyebrow">{{ config.eyebrow }}</p>
                <h2 v-if="config.heading" class="th-h2">{{ config.heading }}</h2>
                <p v-if="config.intro" class="th-btns__intro">{{ config.intro }}</p>
            </div>
            <div v-if="items.length" class="th-btns__row">
                <SiteButton v-for="(b, i) in items" :key="i" :item="b" />
            </div>
            <p v-else-if="editing" class="th-small th-btns__empty">Add buttons in the editor.</p>
        </div>
    </section>
</template>

<style scoped>
.th-btns__head { margin-bottom: clamp(18px, 2.5vw, 28px); }
.th-btns__intro { margin: 12px 0 0; font-size: 17px; color: var(--text-sub, var(--th-muted)); max-width: 60ch; text-wrap: pretty; }
.th-btns__row { display: flex; flex-wrap: wrap; gap: 12px; align-items: center; }
.th-btns__row :deep(.tiq-sb__title) { font-family: var(--th-display); font-weight: 800; }
.th-btns__row :deep(.tiq-sb--button .tiq-sb__title) { font-family: inherit; font-weight: 600; }
.th-btns--center { text-align: center; }
.th-btns--center .th-btns__row { justify-content: center; }
.th-btns--center .th-btns__intro { margin-left: auto; margin-right: auto; }
.th-btns--right { text-align: right; }
.th-btns--right .th-btns__row { justify-content: flex-end; }
.th-btns--right .th-btns__intro { margin-left: auto; }
.th-btns__empty { font-style: italic; }
</style>
